import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function General() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">General</Heading>
      <Accordion size="large" heading="What is the difference between an airline credit and a Luxury Escapes credit?">
        <BodyText variant="large">
          The difference between airline credits and Luxury Escapes credits is listed below:
        </BodyText>
        <ol>
          <li>
            <BodyText variant="large" weight="bold">Airline Credit:</BodyText>
          </li>
          <Group direction="vertical" gap={12}>
            <ul>
              <li>
                <BodyText variant="large">
                  Airline credits are typically provided by airlines as a form of compensation or refund for future travel.
                </BodyText>
              </li>
              <li>
                <BodyText variant="large">
                  These credits are specific to the airline issuing them and can usually only be used for bookings with that particular airline.
                </BodyText>
              </li>
              <li>
                <BodyText variant="large">
                  Some airline credits may have restrictions, such as being tied to a specific individual or route, depending on the airline's policy.
                </BodyText>
              </li>
            </ul>
            <li>
              <BodyText variant="large" weight="bold">Luxury Escapes Credit:</BodyText>
            </li>
          </Group>
          <ul>
            <li>
              <BodyText variant="large">
                Luxury Escapes credits are earned by travellers as rewards for spending under budget.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                These credits are assigned to the traveller's personal account within the Luxury Escapes platform.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Luxury Escapes credits are intended for private use by the traveller, allowing them to redeem the credits for discounts on future travel bookings through Luxury Escapes.
              </BodyText>
            </li>
          </ul>
        </ol>
      </Accordion>
      <Accordion size="large" heading="How does LE Business Traveller's referral program work?">
        <BodyText variant="large">
          The LE Business Traveller referral program allows members to receive A$2,000 in Luxury Escapes credit when they refer a qualified business. If you have an existing Business Traveller account, you can find your referral code on your homepage.
        </BodyText>
        <br />
        <BodyText variant="large">
          The following terms and conditions apply:
        </BodyText>
        <ul>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">
                The A$2,000 Luxury Escapes credit is applied to the referrer account for all qualified business referrals.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                A qualified business referral occurs when the referred business spends A$25,000 (net of refunds) on travel through LE Business Traveller.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Your referral credit will be added to your account at the end of the month in which your referee reaches the A$25,000 target, as outlined above.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Luxury Escapes staff and family members are not eligible for the Referral Program.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                There is no limit on the number of referrals an individual may make.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Luxury Escapes credit earned through the referral program may be used on all accommodation, tours, cruises, experiences and travel insurance purchased through Luxury Escapes. Luxury Escapes credit earned through the referral program may not be used to purchase flights (including accommodation packages bundled with flights) or Luxury Escapes gift cards.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Credit will expire 12 months after it has been credited to your account (unless such other period is stated by Luxury Escapes in writing).
              </BodyText>
            </li>
          </Group>
        </ul>
      </Accordion>
    </Group>
  )
}
